import { Skeleton, SkeletonText } from '~/components';

import { skeletonCardStyle, skeletonHeaderStyle, skeletonProfilePictureStyle, skeletonTextWrapperStyle } from './ForumPostPreview.css';

export const ForumPostPreviewSkeleton = () => {
  return (
    <Skeleton className={skeletonCardStyle}>
      <header className={skeletonHeaderStyle}>
        <div className={skeletonProfilePictureStyle} />
        <div className={skeletonTextWrapperStyle}>
          <SkeletonText fontSize="small" lineHeight="snug" width="50%" />
          <SkeletonText fontSize="tiny" width="30%" />
        </div>
      </header>

      <SkeletonText width="70%" />

      <div>
        <SkeletonText fontSize="small" />
        <SkeletonText fontSize="small" />
      </div>
    </Skeleton>
  );
};
